<app-pan-video-status-chip [status]="params.data.status === 'active' ? 'healthy' : 'unhealthy'"></app-pan-video-status-chip>
